import React from "react";
import { Link } from "react-router-dom";
import howItWorksBanner from "../../assets/how-it-works-banner.webp";
import { ArrowRight, Sparkles } from "lucide-react";

function HowItWorksHero() {
  const scrollToTimeline = () => {
    const el = document.getElementById("pipeline-timeline");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative overflow-hidden bg-white pt-6 pb-14 sm:pt-8 sm:pb-18 lg:pt-10 lg:pb-22">
      {/* Soft Background Ambient Radial Gradients */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_15%_35%,rgba(46,229,162,0.12),transparent_42%),radial-gradient(circle_at_85%_55%,rgba(0,135,81,0.06),transparent_44%)]"
      />

      <div className="section-container relative z-10">
        
        {/* ================= BREADCRUMB ================= */}
        <nav className="flex items-center gap-2 font-jakarta text-[13px] text-[#6b7280] mb-6 sm:mb-8">
          <Link
            to="/"
            className="hover:text-[var(--hero-green)] transition-colors"
          >
            Home
          </Link>
          <span className="text-[#9ca3af]">›</span>
          <span className="font-semibold text-[#111827]">
            How It Works
          </span>
        </nav>

        <div className="grid grid-cols-1 items-center gap-10 md:gap-12 lg:grid-cols-12 lg:gap-10 xl:gap-14">
          
          {/* ================= LEFT COLUMN: HERO CONTENT ================= */}
          <div className="lg:col-span-6 xl:col-span-6">
            
            {/* Tag Badge */}
            <span className="inline-flex items-center gap-1.5 rounded-full bg-[var(--hero-green-light)] px-3 py-1 font-jakarta text-[11.5px] sm:text-[12px] font-bold text-[var(--hero-green)] border border-[var(--hero-green-border)] shadow-xs mb-3.5 sm:mb-4">
              <Sparkles size={13} className="text-[var(--hero-green)]" />
              <span>CLEARANCE PIPELINE 2.0</span>
            </span>

            {/* Main Heading with DSA Green Color on "disbursal" */}
            <h1 className="font-syne text-[28px] sm:text-[38px] md:text-[46px] lg:text-[54px] xl:text-[60px] font-bold leading-[1.15] tracking-[-0.5px] sm:tracking-[-1.5px] text-[#111827] text-balance">
              How a lead becomes a <span className="text-[var(--hero-green)]">disbursal</span>.
            </h1>

            {/* Description */}
            <p className="mt-4 sm:mt-5 max-w-[580px] font-jakarta text-[15px] sm:text-[16.5px] lg:text-[17px] leading-[1.65] text-[#556369]">
              Seven transparent, timestamped milestones. DSAs and partner
              lenders see the exact same real-time ledger simultaneously — from
              2-minute filing to payout.
            </p>

             

            {/* Action Buttons */}
            <div className="mt-8 flex flex-col items-stretch gap-3.5 sm:flex-row sm:items-center sm:gap-4">
              <button
                type="button"
                onClick={scrollToTimeline}
                className="inline-flex h-[50px] items-center justify-center gap-2 rounded-full bg-[var(--hero-green)] px-7 font-jakarta text-[15px] font-bold text-white shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:bg-[var(--hero-green-hover)] hover:shadow-lg outline-none focus:outline-none cursor-pointer"
              >
                <span>View 7-Stage Pipeline</span>
                <ArrowRight size={17} strokeWidth={2.4} />
              </button>

              <Link
                to="/for-dsas"
                className="inline-flex h-[50px] items-center justify-center rounded-full border border-[#d6e2db] bg-white px-7 font-jakarta text-[15px] font-bold text-[#111827] shadow-2xs transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#f3f7f5] hover:border-[#cbdad1] outline-none focus:outline-none"
              >
                Join as DSA
              </Link>
            </div>

          </div>

          {/* ================= RIGHT COLUMN: HERO BANNER IMAGE ================= */}
          <div className="lg:col-span-6 xl:col-span-6 flex items-center justify-center">
            <img
              src={howItWorksBanner}
              alt="Finverse How It Works Pipeline"
              className="w-full max-w-[580px] h-auto object-contain"
              loading="eager"
              decoding="async"
            />
          </div>

        </div>

      </div>
    </section>
  );
}

export default HowItWorksHero;
